import { render, staticRenderFns } from "./List.vue?vue&type=template&id=43fa6f80&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fa6f80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43fa6f80')) {
      api.createRecord('43fa6f80', component.options)
    } else {
      api.reload('43fa6f80', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=43fa6f80&scoped=true", function () {
      api.rerender('43fa6f80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/staffDirectory/List.vue"
export default component.exports